import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=06d47670&scoped=true"
import script from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatBot.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=06d47670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d47670",
  null
  
)

export default component.exports